export default __webpack_public_path__ + "static/media/corner-rosalita.c133bc81.webp";